import { Link } from "react-router-dom";
import { Twitter, Instagram, Linkedin } from "lucide-react";
import { Logo } from "@/components/Logo";

const COLS = [
  { title: "Links Úteis", links: [["Home", "/"], ["Sobre", "/"], ["Planos", "/planos"]] },
  { title: "Conta", links: [["Minha conta", "/feed"], ["Criar conta", "/cadastro"], ["Recuperar conta", "/recuperar-senha"]] },
];

export function Footer() {
  return (
    <footer className="mc-grad-footer text-white mt-auto" data-testid="site-footer">
      <div className="mc-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <Logo light />
            <div className="flex gap-3 mt-6">
              {[Twitter, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" data-testid={`footer-social-${i}`}
                  className="w-9 h-9 rounded-lg bg-white/15 hover:bg-white/25 transition-colors flex items-center justify-center">
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-bold text-lg mb-4">{col.title}</h4>
              <ul className="space-y-3 text-white/85 text-[15px]">
                {col.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="hover:text-white transition-colors">{label}</Link></li>
                ))}
                {col.title === "Links Úteis" && (
                  <li><a href="/compracomigo" className="hover:text-white transition-colors">CompraComigo</a></li>
                )}
              </ul>
            </div>
          ))}
          <div>
            <h4 className="font-bold text-lg mb-4">Contato</h4>
            <ul className="space-y-3 text-white/85 text-[15px]">
              <li>(43) 1151-2920</li>
              <li>Londrina, PR</li>
              <li>meajuda@moracomigo.com</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/20 mt-10 pt-6 flex flex-col sm:flex-row justify-between gap-2 text-sm text-white/80">
          <span>Política de Privacidade</span>
          <span>© 2025 Mora Comigo, Todos os direitos reservados</span>
        </div>
      </div>
    </footer>
  );
}
